module.exports = __webpack_public_path__ + "img/ru.1f582e2b.svg";